import React from 'react';
import { useTranslation } from 'react-i18next';
// import OrdersTable from '../../components/Orders/OrdersTable';
import OrdersList from '../../components/Shop/Orders/OrdersList';
import PageHeader from '../../components/Layout/PageHeader/PageHeader';

function Orders() {
  const { t } = useTranslation();

  return (
    <>
      <PageHeader
        title={t('orders.header')}
        subtitle={t('orders.subtitle')}
      />
      <div className="container">
        {/* <OrdersTable /> */}
        <OrdersList limit={25} />
      </div>
    </>
  )
}

export default Orders;